<template>
    <div>
         <Table border :columns="columns1" :data="data1" :span-method="handleSpan">
             <template slot-scope="{ row, index }" slot="action1">
              <Button type="success" size="small" icon="md-add" @click="editKPI(row,index)"></Button>
              <Button type="warning" size="small" icon="md-remove" @click="deleteKPIAll(row,index)" style="margin-left:15px"></Button>
            </template>
            <template slot-scope="{ row ,index }" slot="targetItem">
                <Input type="textarea" v-model="row.targetItem" :autosize="true" @on-change="targetItemChange(row,index,'targetItem')" />
            </template>
            <template slot-scope="{ row ,index }" slot="content" style="width:100%">
                <Input type="textarea" v-model="row.content" :autosize="true" @on-change="targetItemChange(row,index,'content')"/>
            </template>
            <template slot-scope="{ row,index }" slot="weight">
               <DatePicker type="date" v-model="row.weight" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'weight')"/>
            </template>
            <template slot-scope="{ row,index }" slot="method">
                <DatePicker type="date" v-model="row.method" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'method')"/>
            </template>
            <template slot-scope="{ row,index }" slot="dataFrom">
                <Input type="textarea" v-model="row.dataFrom" :autosize="true" @on-change="targetItemChange(row,index,'dataFrom')"/>
            </template>
            <template slot-scope="{ row, index }" slot="action12">
              <!-- <Button type="success" size="small" @click="editKPI(row,index)">新增</Button> -->
              <Button :disabled="!row.deleteState" type="warning" size="small" icon="md-trash" @click="deleteKPI12(row,index)"></Button>
            </template>
          </Table>
          <div style="display: flex; justify-content: flex-end; margin-top:10px">
            <Button @click="addKPI()">新增</Button>
          </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            // KPI 指标
            columns1: [
                {
                    title: "操作",
                    slot:"action1",
                    align: "center",
                    minWidth: 120,
                },
                {
                    title: "绩效重点",
                    slot:'targetItem',
                    minWidth:200,
                },
                {
                    title: "详情描述",
                    slot:'content',
                    align: "center",
                    minWidth:300,
                },
                {
                    title: "开始时间",
                    slot:'weight',
                    align: "center",
                    minWidth:160,
                },
                {
                    title: "结束时间",
                    slot:'method',
                    align: "center",
                    minWidth:160,
                },
                {
                    title: "详情指标",
                    slot:'dataFrom',
                    align: "center",
                    minWidth:220,
                },
                {
                    title: "删除",
                    slot:"action12",
                    align: "center",
                    minWidth: 80,
                },
            ],
            data1:[],
            kpiIdNum:0,
            spanb:[],
        }
    },
    methods:{
        editKPI(row,index) {
            this.$set(this.data1[index],'deleteState',true)
            let array=[]
            this.data1.forEach(res => {
                if(res.id==row.id){
                    array.push(res)
                }
            })
            const ids = array.map(value=>value.id);
            const idsSet = new Set(ids);
            if(idsSet.size == ids.length){
                this.data1.splice(index+1,0,{id:row.id,targetItem:row.targetItem,content:row.content,weight:row.weight,method:row.method,dataFrom:'',deleteState:true})
            }else {
                this.data1.splice(index+ids.length,0,{id:row.id,targetItem:row.targetItem,content:row.content,weight:row.weight,method:row.method,dataFrom:'',deleteState:true})
            }
            this.tableSpan()
        },
        deleteKPI12(row,index){
            this.data1.splice(index,1)
            this.tableSpan()
            let array=[]
            this.data1.forEach(res => {
                if(res.id==row.id){
                    array.push(res)
                }
            })
            const ids = array.map(value=>value.id);
            const idsSet = new Set(ids);
            if(idsSet.size == ids.length){
                this.data1.forEach((res,index) => {
                    if(res.id==row.id){
                        this.$set(this.data1[index],'deleteState',false)
                    }
                })
            }
        },
        deleteKPIAll(row,index){
            var newArray = this.data1.filter((val)=>{return val.id!=row.id;});
            this.data1=newArray
        },
        addKPI(){
            this.data1.push({targetItem:'',content:'',weight:'2022-1-1',method:'2022-12-31',dataFrom:'',id: this.kpiIdNum++,children:[],deleteState:false})
            this.tableSpan()
        },
        targetItemChange(row,index,key){
            key=='targetItem'?this.$set(this.data1[index],'targetItem',row.targetItem):''
            key=='weight'?this.$set(this.data1[index],'weight',row.weight):''
            key=='content'?this.$set(this.data1[index],'content',row.content):''
            key=='method'?this.$set(this.data1[index],'method',row.method):''
            key=='dataFrom'?this.$set(this.data1[index],'dataFrom',row.dataFrom):''
        
        },
        //单元格合并
        handleSpan ({ row, column, rowIndex, columnIndex }) {
            if(this.spanb.length>0){
                if (columnIndex === 1 || columnIndex === 0 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
                    if(this.spanb[rowIndex]){
                        return {
                            rowspan:this.spanb[rowIndex],
                            colspan:1
                        }
                    }else{
                        return {
                            rowspan: 0,
                            colspan: 1
                        }
                    }
                }
            }
        },
        tableSpan(){
            let contactDotb = 0;
            let spanb = [];
            this.data1.forEach((item,index)=>{
                if(index === 0){
                    spanb.push(1)
                }else {
                    if (item.id === this.data1[index - 1].id) {
                        spanb[contactDotb] += 1;
                        spanb.push(0)
                    } else {
                        contactDotb = index
                        spanb.push(1)
                    }
                }
            })
            this.spanb = spanb;
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-table-cell-slot {
    width:100%
}
</style>


// WEBPACK FOOTER //
// src/components/process/Apply/components/PersonalGoals.vue